import { WeatherPouringIcon } from './WeatherPouringIcon';

/**
 * author: Austin Andrews
 * id 220955AA-770D-4884-A2ED-F21D2DC2CCDA
 * name weather-pouring
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-pouring.svg
 * tags
 * - Weather 
 * - Agriculture 
 */
export const WeatherHeavyRainIcon = WeatherPouringIcon;
export default WeatherHeavyRainIcon